module.exports = __webpack_public_path__ + "img/home_up_normal.a9ffd899.svg";